import { traffic2 } from '../../utils/buildAnalyticsEvents';

export const ERROR_EVENTS = {
  ERROR_PAGE_IMPRESSION: {
    ...traffic2('marketing.error_page.impression')
  },
  ERROR_RETRY_BUTTON_CLICK: {
    ...traffic2('marketing.error_page.retry_button.click')
  }
};
